import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';

const rows = [
  {
    id: 'amazonOrderId', disablePadding: true, label: 'Amazon Order', align: 'left', width: 80,
  },
  {
    id: 'buyerName', disablePadding: false, label: 'Buyer Name', align: 'left', width: 70,
  },
  {
    id: 'sku', disablePadding: false, label: 'SKU', align: 'left', width: 50,
  },
  {
    id: 'productName', disablePadding: false, label: 'Product Name',align: 'left', width: 500,
  },
  {
    id: 'quantityShipped', disablePadding: false, label: 'Quantity', align: 'right', width: 50,
  },
  {
    id: 'itemPrice', disablePadding: false, label: 'Price', align: 'right', width: 60,
  },
  {
    id: 'currency', disablePadding: false, label: 'Currency', align: 'left', width: 50,
  },
  {
    id: 'carrier', disablePadding: false, label: 'Carrier', align: 'left', width: 60,
  },
  {
    id: 'trackingNumber', disablePadding: false, label: 'Tracking Number', align: 'left', width: 100,
  },  
  {
    id: 'salesChannel', disablePadding: false, label: 'Sales Channel', align: 'left', width: 85,
  },
  {
    id: 'purchaseDate', disablePadding: false, label: 'Purchase Date', align: 'left', width: 60,
  },  
  {
    id: 'shipmentDate', disablePadding: false, label: 'Shipment Date', align: 'left', width: 60,
  },
];

const createSortHandler = (property, onRequestSort) => (event) => {
  onRequestSort(event, property);
};

const CustomerTableHead = ({
  onSelectAllClick, order, orderBy, numSelected, rowCount, rtl, onRequestSort,
}) => (
  <TableHead>
    <TableRow>      
      {rows.map(row => (
        <TableCell
        //  className="material-table__cell material-table__cell--sort material-table__cell-right"
          key={row.id}
            align={row.align}
        //  align={rtl.direction === 'rtl' ? 'right' : 'left'}
          padding={row.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === row.id ? order : false}
          width={row.width}
        //  style={{ maxWidth: row.width }} 
        >
          <TableSortLabel
            active={orderBy === row.id}
            direction={order}
            onClick={createSortHandler(row.id, onRequestSort)}
            className="material-table__sort-label"
            dir="ltr"
          >
            {row.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

CustomerTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  rtl: RTLProps.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(CustomerTableHead);
